export default {
  "addStandard.title": "Add Standard Products",
  "addStandard.explain":
    "Note: For the wardrobe products please comfirm the grouping before adding, otherwise the grouping/ungrouping operation may lead to the loss of data.",
  "addStandard.showCaxa": "Display the standard design or not:",
  "addStandard.caseName": "Name of Project",
  "addStandard.product": "Combined Cabinet",
  "addStandard.productDetail": "Details of Standard Products",
  "addStandard.operate": "Operation",
  "addStandard.open": "Yes",
  "addStandard.close": "No",
  "addStandard.packageType": "Package Type",
  "addStandard.specifications": "Specifications",
  "addStandard.productCode": "Product Code",
  "addStandard.model": "Model",
  "addStandard.classify": "Classify",
  "addStandard.details": "Details",
  "addStandard.order": "(Order)",
  "addStandard.notOrder": "(Not order)",
  "addStandard.edit": "Edit",
  "addStandard.designScheme": "(Design Scheme)",
  "addStandard.parameters": "Order parameters",
  "addStandard.FaucetModel": "Faucet model",
  "addStandard.FaucetCode": "Faucet code",
  "addStandard.nonStandard": "Is it non-standard",
  "addStandard.installingBasin": "Method for installing basin",
};



// WEBPACK FOOTER //
// ./src/locales/lang/en-US/addStandard/settings.js